







































import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import {mixin as clickaway} from 'vue-clickaway';
import { RuleConditionsManager } from './ruleConditionsManager';
import ConditionGroupBuilder, { ConditionGroupUpdate } from '@/shared/components/conditions/ConditionGroupBuilder.vue';
import CapableAppPicker from '@/shared/components/capableAppPicker/CapableAppPicker.vue';
import { ConfiguredAppIntegration } from '@/features/apps/shared/models/configuredAppIntegration';
import { botsApi } from '../../services/bots';
import { RuleViewModel } from '../../models/ruleViewModel';
import { validationMixin } from 'vuelidate';
import { required, minLength } from 'vuelidate/lib/validators';
import TagBox from '@/shared/components/TagBox.vue';
import { FollowUpActionViewModel, FollowUpActionType, BotActionAppViewModel } from '../../models';
@Component({
	mixins: [
		clickaway,
		validationMixin
	],
	validations: {
		providedRule: {
			required,
			conditions: {
				conditions: {
					required,
					minLength: minLength(1)
				}
			},
			actions: {
				required,
				minLength: minLength(1)
			}
		}
	},
	components: {
		ConditionGroupBuilder,
		CapableAppPicker,
		TagBox
	}
})
export default class Rule extends Vue {
	@Prop() public rule: RuleViewModel;
	@Prop() public ruleConditionsManager: RuleConditionsManager;

	public hasInvalidConditions = false;
	public providedRule: RuleViewModel = {
		conditions: {
			type: 'and',
			conditions: []
		},
		actions: []
	};

	@Watch('rule', { immediate: true, deep: true })
	public onValueChanged(value: RuleViewModel) {
		if (value) {
			this.providedRule = value;
		}
	}

	public conditionUpdated(update: ConditionGroupUpdate) {
		this.hasInvalidConditions = update.invalid;
		const clone = JSON.parse(JSON.stringify(this.providedRule)); // to prevent updating the providedRule which would kick off processing in child
		clone.conditions = update.conditionGroup;
		this.$emit('updated', clone, this.hasInvalidConditions);
	}


	public actionsChanged(selectedApps: BotActionAppViewModel[]) {
		const appActions = selectedApps.map<FollowUpActionViewModel>(app => ({
			type: FollowUpActionType.AppIntegration,
			app
		}));
		this.providedRule.actions = appActions;
		this.$emit('updated', this.providedRule, this.hasInvalidConditions);
	}

	public configRequest(workspaceId: string, installedAppId: string, values: any, previousValues: any, componentId: any) {
		return botsApi.botAppConfig(workspaceId, installedAppId, values, previousValues, componentId);
	}

	public deleteRule() {
		this.$emit('deleted');
	}

	public getSelectedFollowUpApps(): Array<ConfiguredAppIntegration | undefined> {
		return this.providedRule.actions
			.filter(action => action.type === FollowUpActionType.AppIntegration)
			.filter(action => action.app !== undefined)
			.map(action => action.app);
	}
}
